import CommonTooltip from "components/Tooltip/CommonTooltip";
import moment from "moment-timezone";
import styled from "styled-components";

import { getRandomColor } from "../../../utils/getRandomColor";
import {
  formatHmsString,
  getHours,
  getHoursWithSeconds,
  toHHMMSS,
} from "../../../utils/helper";
import { TimeDisplay } from "../TimeDisplay";

const TimeDiv = styled.div`
  height: 30px;
  width: 90px;
  border-radius: ${({ theme }) => theme.borderRadii.button};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.font.pageText.size};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  background: ${({ backgroundColor }) => backgroundColor};
  border: ${({ isActive, theme }) =>
    isActive ? `2px solid ${theme.colors.main.primary}` : "none"};
  z-index: ${({ largerZ }) => (largerZ ? 2001 : "auto")};
  /*
  @media screen and (max-width: 1600px) {
    margin-top: 0px;
    max-height: 28px;
    font-size: 12.5px;
  }
    */
`;

const TimeBlankDiv = styled.div`
  height: 30px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.font.pageText.size};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  background: ${({ theme }) => theme.colors.main.white};
  margin: 10px auto;
  border: ${({ isActive, theme }) =>
    isActive ? `2px solid ${theme.colors.main.primary}` : "none"};
  border-radius: ${({ theme }) => theme.borderRadii.button};
`;

const TimeSpan = ({
  event,
  selectedMember,
  getTimesheetDetails,
  handleSetUserData,
  backgroundColor,
  setSelectedPanelDate,
  activeDate,
  detailsPanelIsOpen,
}) => {
  return (
    <>
      {event.title === "0h 00m" || event.title === "0h 0m" || event.title === "-"  ? (
        <TimeBlankDiv
          isActive={
            activeDate === moment(event.event.start).format("YYYY-MM-DD") &&
            detailsPanelIsOpen
          }
        >
          -
        </TimeBlankDiv>
      ) : (
        <TimeDiv
          style={{ cursor: "pointer" }}
          backgroundColor={backgroundColor}
          onClick={() => {
            getTimesheetDetails(
              moment(event.event && event.event.start),
              selectedMember
                ? selectedMember.id
                : localStorage.getItem("user_id"),
            );
            handleSetUserData(
              moment(event.event && event.event.start),
              event.title,
            );
            setSelectedPanelDate(
              moment(event.event.start).format("YYYY-MM-DD"),
            );
          }}
          isActive={
            activeDate === moment(event.event.start).format("YYYY-MM-DD") &&
            detailsPanelIsOpen
          }
          largerZ={detailsPanelIsOpen}
        >
          {/* {event.title} */}

          <CommonTooltip tooltipText={formatHmsString(event.title)}>
            <TimeDisplay marginLeft={"0px"} timeString={event.title} />
          </CommonTooltip>
        </TimeDiv>
      )}
    </>
  );
};

export default TimeSpan;
